import React, { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import api from "@/lib/api";

function ago(iso) {
    if (!iso) return "";
    const s = (Date.now() - new Date(iso).getTime()) / 1000;
    if (s < 3600) return `${Math.max(1, Math.floor(s / 60))}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return `${Math.floor(s / 86400)}d ago`;
}

// Auto-scrolling marquee of recent, anonymized member signups by city.
export default function CitiesTicker() {
    const [items, setItems] = useState([]);
    const [paused, setPaused] = useState(false);
    const track = useRef(null);

    useEffect(() => {
        api.get("/public/recent-signups").then((r) => setItems(r.data || [])).catch(() => {});
    }, []);

    if (!items.length) return null;
    const loop = [...items, ...items];

    return (
        <div className="relative mt-6 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]" data-testid="cities-ticker">
            <div
                ref={track}
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
                className="flex w-max gap-3"
                style={{ animation: "marquee 90s linear infinite", animationPlayState: paused ? "paused" : "running" }}
            >
                {loop.map((it, i) => (
                    <span key={i} className="flex flex-none items-center gap-2 whitespace-nowrap rounded-full bg-white/15 px-4 py-2 text-sm text-white backdrop-blur">
                        <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-300" />
                        <MapPin className="h-3.5 w-3.5 opacity-80" />
                        New member in <b className="font-700">{it.city}{it.state ? `, ${it.state}` : ""}</b>
                        {it.created_at && <span className="text-white/60">· {ago(it.created_at)}</span>}
                    </span>
                ))}
            </div>
        </div>
    );
}
